import * as types from "./store.constant";

const defaultState = { gameId:null , language:"en" , className:"ltr text-left" , items:null ,
 serverError:null , achievements:null , user:null};

export default function (state = defaultState, action = {}) {
    switch (action.type) {
        case types.STORE_ACTION_PERSIST:
            return {
                ...state,
                ...action.payload,
            };
        case types.STORE_ACTION_CLEAR:
            return defaultState;
        default:
            return state;
    }
}
